import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { OpenInNew } from "@material-ui/icons";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import React from "react";
import _ from "underscore";
import { getBlockChainUrl, getTransactionUrl } from "../../helpers/utility";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1),
  },
  icon: {
    [theme.breakpoints.down("md")]: {
      position: "relative",
      top: -10,
    },
  },
  chip: {
    marginRight: theme.spacing(1),
    background: theme.palette.info.main,
    color: "white",
  },
}));

export default function ClientList(props) {
  const classes = useStyles();
  const [i, setI] = React.useState("")
  const actionRenderer = () => {
    return {
      name: "address",
      label: "Info",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return (
            <a target="_blank" href={getBlockChainUrl("bnb") + value}>
              <OpenInNew
                className={classes.icon}
                color="secondary"
              />
            </a>
          );
        },
      },
    };
  };

  const hashRenderer = () => {
    return {
      name: "id",
      label: "Client Hash",
      options: {
        setCellProps: () => ({
          align: "center",
        }),
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          let item = _.find(props.clients, (s) => s.id === value);
          return item.transactionhash ? (
            <a
              target="_blank"
              href={getTransactionUrl(item.type) + item.transactionhash}
            >
              Click
            </a>
          ) : (
            <></>
          );
        },
      },
    };
  };

  const chargeRenderer = () => {
    return {
      name: "id",
      label: "Charge Hash",
      options: {
        setCellProps: () => ({
          align: "center",
        }),
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          let item = _.find(props.clients, (s) => s.id === value);
          return item.parentTransactionHash ? (
            <a
              target="_blank"
              href={getTransactionUrl(item.type) + item.parentTransactionHash}
            >
              Click
            </a>
          ) : (
            <></>
          );
        },
      },
    };
  };

  const statusRenderer = () => {
    return {
      name: "status",
      label: "Status",
      options: {
        setCellProps: () => ({
          align: "center",
        }),
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <Chip
              label={value}
              style={{
                background:
                  value === "Completed"
                    ? "green"
                    : value === "Admin Pending"
                      ? "goldenrod"
                      : value === "Rejected"
                        ? "red"
                        : "teal",
              }}
            />
          );
        },
      },
    };
  };

  const columns = [
    {
      name: "createdDate",
      label: "Client Time",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: false,
        sort: false,

      },
    },

    {
      name: "address",
      label: "Address",
      options: {
        filter: false,
        sort: false,

      },
    },
    actionRenderer(),
  ];

  const tenants = {};

  props.users &&
    props.users.forEach((x) => {
      tenants[x.id] = x.tenantName;
    });

  const data = props.clients && props.clients.map((item) => {
    let fees = item.transactionChargeFees;
    if (!fees) {
      fees = parseFloat(item.transactionCharge / item.coinValue).toFixed(8);
    }
    return {
      id: item.id,
      createdDate: moment.unix(item.createdOn.seconds).format("lll"),
      address: item.address,
      email: item.email,
    };
  });

  return (
    <div className={classes.container}>
      <MUIDataTable
        title={"Client`s List"}
        data={data}
        columns={columns}
        options={{
          filterType: "checkbox",
          selectableRows: "none",
          rowsPerPageOptions: [10],
        }}
      />
    </div>
  );
}
